<template>
  <div
    role="tablist"
    aria-label="Tipo de pagamento"
    class="inline-flex w-fit max-w-full flex-wrap gap-1 rounded-lg border border-lightGray30 bg-white p-1"
    :data-testid="testId"
  >
    <button
      v-for="option in TAB_OPTIONS"
      :key="option.value"
      type="button"
      role="tab"
      class="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-[13px] font-medium"
      :class="
        tab === option.value ? 'bg-primary text-white' : 'text-neutral50 hover:bg-lightGray30/40'
      "
      :aria-selected="tab === option.value"
      :data-testid="`${testId}-${option.value}`"
      @click="onSelect(option.value)"
    >
      {{ option.label
      }}<span
        v-if="counts"
        class="rounded-full px-1.5 text-[11px] tabular-nums"
        :class="tab === option.value ? 'bg-white/20' : 'bg-lightGray30'"
        :data-testid="`${testId}-${option.value}-count`"
        >{{ counts[option.value] }}</span
      >
    </button>
  </div>
</template>

<script setup lang="ts">
import type { PriorityTab } from '@/Network/Types/Responses/PriorityPaymentsResponses'

/** Q9: "Todos" é o padrão; na aba de um tipo vale o SLA daquele tipo (§3.4). */
const TAB_OPTIONS: { value: PriorityTab; label: string }[] = [
  { value: 'ALL', label: 'Todos' },
  { value: 'IN_CASH', label: 'À vista' },
  { value: 'ANTECIPE', label: 'Antecipe' }
]

const props = withDefaults(
  defineProps<{
    tab: PriorityTab
    /** `slaCounters.byTab`; `null` quando o BE não manda (anterior ao SLA). */
    counts: Record<PriorityTab, number> | null
    testId?: string
  }>(),
  { testId: 'priority-payments-tabs' }
)

const emit = defineEmits<{ 'update:tab': [tab: PriorityTab] }>()

function onSelect(value: PriorityTab): void {
  if (value !== props.tab) emit('update:tab', value)
}
</script>
